import { HelpButton, CustomMenu as BaseHelpMenu } from '@zageno/ui';

export default function HelpMenu() {
  const defaultItems = [
    {
      title: 'Contact Us',
      link: 'https://zageno.freshdesk.com/support/solutions/articles/79000123703-how-can-i-contact-customer-service-',
    },
    {
      title: 'Onboarding Guide',
      link: 'https://try.zageno.com/platform-onboarding-guide',
    },
    {
      title: 'Product Feedback',
      link: 'https://feedback.zageno.com/',
    },
    {
      title: 'FAQ',
      link: 'https://zageno.freshdesk.com/support/solutions/79000057615',
    },
  ];

  return (
    <BaseHelpMenu items={defaultItems}>
      <HelpButton sx={{ display: { xs: 'none', md: 'inline-flex' } }} />
    </BaseHelpMenu>
  );
}
